/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import { useDrag } from "react-dnd";

interface DraggableNumberProps {
  number: number;
  index: number;
  moveNumber: (fromIndex: number, toIndex: number) => void;
}

const DraggableNumber: React.FC<DraggableNumberProps> = ({ number, index }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'number',
    item: { type: 'number', number, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [number, index]);

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        fontWeight: 'bold',
        cursor: 'move',
        padding: '5px',
        margin: '5px',
        backgroundColor: '#f0f0f0',
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid black',
        borderRadius: '10px',
      }}
    >
      {number}
    </div>
  );
};

export default DraggableNumber;
